export default {
  //登陆信息
  tokenInfo: {
    // salt: "baispsqe261d6c4vyvcxwyaxxb",
    // token: "da2b359276bca90e18d6c0219dc5c362"
  },
  userInfo: {
    userName: "",
    headImg: "",
  },
  ewmData: "",
  partner_code: "",
  //填写订单选择地址
  addressInfo: "",
  //填写订单选择受检人
  BpeopleInfo: "",
  orderList:[],
  tubesList:[],
  patientInfo:{},

  editTubes:[],
  editPatientInfo:{},
  cartItems: []
};
